// extracted by mini-css-extract-plugin
export default {"wrapper":"StepNavigation_wrapper__xADxP","btnBack":"StepNavigation_btnBack__N33ng","buttons":"StepNavigation_buttons__3UNY1"};